function toggleWindow(edit, windowKey) {
  const windows = [
    "storyletsWindow",
    "languagesWindow",
    "variablesWindow",
    "projectsWindow",
    "settingsWindow",
    "previewWindow",
    "helpWindow",
  ];

  windows.forEach((key) => {
    edit[key] = key === windowKey ? !edit[key] : false;
  });
}

// Individual window toggling functions
export function storyletsWindow(edit) {
  toggleWindow(edit, "storyletsWindow");
}

export function languagesWindow(edit) {
  toggleWindow(edit, "languagesWindow");
}

export function projectsWindow(edit) {
  toggleWindow(edit, "projectsWindow");
}

export function variablesWindow(edit) {
  toggleWindow(edit, "variablesWindow");
}

export function previewWindow(edit) {
  toggleWindow(edit, "previewWindow");
}

export function helpWindow(edit) {
  toggleWindow(edit, "helpWindow");
}

export function settingsWindow(edit) {
  toggleWindow(edit, "settingsWindow");
}

export function noWindow(edit) {
  const windows = [
    "storyletsWindow",
    "languagesWindow",
    "variablesWindow",
    "projectsWindow",
    "settingsWindow",
    "previewWindow",
    "helpWindow",
  ];

  windows.forEach((key) => {
    edit[key] = false;
  });
}
